import { ReactNode } from 'react';

import { AttachmentFragment } from '@spotify/confidence-graphql';
import {
  ArtifactCardBase,
  DefaultArtifactListItem,
  getArtifactNavigationPath,
} from '@spotify/plugin-confidence-projects-react';

type ResolvedNameHook = (artifact: AttachmentFragment) => string | undefined;

export interface ResolvedListItemProps {
  artifact: AttachmentFragment;
  icon?: ReactNode;
  onSelect: () => void;
  onNavigateToResource?: () => void;
  onDelete?: () => void;
}

export interface ResolvedCardProps {
  artifact: AttachmentFragment;
  onNavigate: () => void;
  onDelete?: () => void;
}

export const makeResolvedArtifactWrappers = (
  useResolvedName: ResolvedNameHook,
) => {
  const ListItem = ({
    artifact,
    icon,
    onSelect,
    onNavigateToResource,
    onDelete,
  }: ResolvedListItemProps) => {
    const navigationPath = getArtifactNavigationPath(artifact.uri);
    const href = navigationPath ? `/${navigationPath}` : undefined;

    return (
      <DefaultArtifactListItem
        artifact={artifact}
        resolvedDisplayName={useResolvedName(artifact)}
        icon={icon}
        href={href}
        onSelect={onSelect}
        onNavigateToResource={onNavigateToResource}
        onDelete={onDelete}
      />
    );
  };

  const Card = ({ artifact, onNavigate, onDelete }: ResolvedCardProps) => (
    <ArtifactCardBase
      artifact={artifact}
      resolvedDisplayName={useResolvedName(artifact)}
      onNavigate={onNavigate}
      onDelete={onDelete}
    />
  );

  return { ListItem, Card };
};
